export const MORE_LIKE_THIS_AMOUNT = 8
